module.exports = __webpack_public_path__ + "img/file-import-solid.a8839d49.svg";